import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import { Spinner } from 'react-bootstrap';

export default function CustomButton(props) {
    return(
        <button style={{height:50,borderRadius:10,minWidth:100,paddingRight:10,margin:'10px auto',display:'block'}} onClick={props?.onClick}>
            {props?.isloading ?<Spinner animation="border" />:
            <>
                {props?.isIcon && <CheckIcon/>}{' '}
                {props?.label}
                </>
        }
      </button>
    )
}

// How to use

// <CustomButton
// label={'Save'}
// isIcon
// />